/*
 * @Copyright 2025. Institute for Future Intelligence, Inc.
 */

import { Checkbox } from 'antd';
import { useStore } from '../../stores/common';
import { MainMenuItem, MainSubMenu } from '../menuItem.tsx';
import { runWithUndo } from '../../undo/setWithUndo';
import i18n, { t } from 'i18next';
import { usePrimitiveStore } from '../../stores/commonPrimitive.ts';
import { useLanguage } from '../../hooks.ts';
import * as Selector from '../../stores/selector';

const AccessoriesMenu = () => {
  const lang = useLanguage();
  const setCommonStore = useStore.getState().set;
  const showInstructionPanel = useStore(Selector.showInstructionPanel);
  const showPeriodicTable = usePrimitiveStore(Selector.showPeriodicTable);
  const setChanged = usePrimitiveStore.getState().setChanged;

  const toggleInstructionPanel = () => {
    setCommonStore((state) => {
      state.projectState.showInstructionPanel = !state.projectState.showInstructionPanel;
    });
    setChanged(true);
  };

  const togglePeriodicTable = () => {
    usePrimitiveStore.getState().set((state) => {
      state.showPeriodicTable = !state.showPeriodicTable;
    });
  };

  return (
    <MainSubMenu label={t('menu.accessoriesSubMenu', lang)}>
      <MainMenuItem stayAfterClick>
        <Checkbox
          style={{ width: '100%' }}
          checked={showInstructionPanel}
          onChange={() => {
            runWithUndo('Show/Hide Instruction', toggleInstructionPanel, toggleInstructionPanel);
          }}
        >
          {i18n.t('menu.accessories.Instruction', lang)}
        </Checkbox>
      </MainMenuItem>

      <MainMenuItem stayAfterClick>
        <Checkbox
          style={{ width: '100%' }}
          checked={showPeriodicTable}
          onChange={() => {
            runWithUndo('Show/Hide Periodic Table', togglePeriodicTable, togglePeriodicTable);
          }}
        >
          {i18n.t('menu.accessories.PeriodicTable', lang)}
        </Checkbox>
      </MainMenuItem>
    </MainSubMenu>
  );
};

export default AccessoriesMenu;
